import React from 'react'
import Nav from '../components/Nav'
import HeroImg from '../components/HeroImg'
import Footer from '../components/Footer'
import Work from '../components/Work'
const home = () => {
  return (
    <div>
      <Nav/>
     <HeroImg/>
     <Work/>
     <Footer/>
    </div>
  )
}

export default home
